import React, { useEffect, useState } from 'react';
import { Form, Alert, Button } from 'react-bootstrap'; // Aggiunto Button per coerenza
import useMediaQuery from '../../hooks/useMediaQuery';
import useRendicontazioneAdmin from '../../hooks/useRendicontazioneAdmin';
import useSuperpartner from '../../hooks/useSuperpartner';
import { alertService } from '../../services/AlertService';
import CustomModal from '../../components/CustomModal/CustomModal';
import CustomTable from '../../components/CustomTable/CustomTable';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import { ACTION_TYPES } from '../../model/actions';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomSearch from '../../components/CustomSearch/CustomSearch';
import RendicontazioneDettaglioModal from '../../components/RendicontazioneDettaglioModal/RendicontazioneDettaglioModal';
import useRendicontazioneSuperpartnerAdminConfigTable from '../../configTable/useRendicontazioneSuperpartnerAdminConfigTable';

const DashboardRendicontazioneSuperpartnerPage = () => {
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const { 
        loadingStateAdmin, 
        findSuperpartnerRendicontazioni, 
        updateStatusSuperpartner, 
        liquidaRendicontazioneSuperpartner, 
        getDettaglioSuperpartner 
    } = useRendicontazioneAdmin();
    
    // Hook corretto per la ricerca
    const { getSuperpartnerByParams } = useSuperpartner();

    const [masterList, setMasterList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [filtri, setFiltri] = useState({ stato: '', superpartner: null });
    
    const [showStatoModal, setShowStatoModal] = useState(false);
    const [showLiquidaModal, setShowLiquidaModal] = useState(false);
    const [selectedRendicontazione, setSelectedRendicontazione] = useState(null);
    const [statoFormData, setStatoFormData] = useState({ stato: '', note: '' });
    const [liquidaFormData, setLiquidaFormData] = useState({ data_liquidazione: '', ricevuta: null });
    const [showDettaglioModal, setShowDettaglioModal] = useState(false);
    const [dettaglioData, setDettaglioData] = useState([]);    

    const rendicontazioneConfigTable = useRendicontazioneSuperpartnerAdminConfigTable();

    const fetchRendicontazioni = async () => {
        const data = await findSuperpartnerRendicontazioni({});
        setMasterList(data);
    };

    useEffect(() => {
        fetchRendicontazioni();
    }, []);

    useEffect(() => {
        let list = [...masterList];
        if (filtri.stato) {
            list = list.filter(item => item.stato === filtri.stato);
        }
        if (filtri.superpartner) {
            list = list.filter(item => item.id_superpartner === filtri.superpartner.id_superpartner);
        }
        setFilteredList(list);
    }, [filtri, masterList]);

    const openStatoModal = (item) => {
        setSelectedRendicontazione(item);
        setStatoFormData({ stato: item.stato, note: item.note || '' });
        setShowStatoModal(true);
    };

    const openLiquidaModal = (item) => {
        setSelectedRendicontazione(item);
        setLiquidaFormData({ data_liquidazione: '', ricevuta: null });
        setShowLiquidaModal(true);
    };

    const handleUpdateStato = async () => {
        const data = { id_rendicontazione: selectedRendicontazione.id_superpartner_rendicontazione, ...statoFormData };
        const success = await updateStatusSuperpartner(data);
        if (success) {
            setShowStatoModal(false);
            fetchRendicontazioni();
        }
    };

    const handleLiquida = async () => {
        if (!liquidaFormData.data_liquidazione || !liquidaFormData.ricevuta) {
            alertService.warn("Per favore, inserisci sia la data che il file della ricevuta."); return;
        }
        const formData = new FormData();
        formData.append('id_rendicontazione', selectedRendicontazione.id_superpartner_rendicontazione);
        formData.append('id_superpartner', selectedRendicontazione.id_superpartner);
        formData.append('data_liquidazione', liquidaFormData.data_liquidazione);
        formData.append('ricevuta', liquidaFormData.ricevuta);
        const success = await liquidaRendicontazioneSuperpartner(formData);
        if (success) {
            setShowLiquidaModal(false);
            fetchRendicontazioni();
        }
    };

    const handleCloseModal = () => {
        setShowStatoModal(false);
        setShowLiquidaModal(false);
        setSelectedRendicontazione(null);
        setShowDettaglioModal(false);
        setDettaglioData([]);
    };

    const openDettaglioModal = async (item) => {
        setSelectedRendicontazione(item);
        setShowDettaglioModal(true);
        const dettagli = await getDettaglioSuperpartner(item.id_superpartner_rendicontazione);
        setDettaglioData(dettagli);
    };
    
    const actions = [
        { type: ACTION_TYPES.VIEW, icon: 'bi-eye-fill text-info', label: 'Dettaglio', onClick: openDettaglioModal },
        { type: ACTION_TYPES.CONFIG, icon: 'bi-pencil-fill text-warning', label: 'Modifica', onClick: openStatoModal },
        { type: ACTION_TYPES.CONFIG, icon: 'bi-check-circle-fill text-success', label: 'Liquida', disabled: (item) => item.stato !== 'Da Liquidare', onClick: openLiquidaModal }
    ];

    return (
        <>
            <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}>
                <div className="container">
                    <div className="d-flex justify-content-between custom-card-header">
                        <div className="d-flex gap-3 custom-card-title my-2">
                            <div className="custom-icon-container"><i className="bi custom-icon bi-clipboard-data-fill fs-2"></i></div>
                            <div className="align-self-center"><span className="fs-4 d-block"><i><b>Dashboard Rendicontazione Superpartner</b></i></span></div>
                        </div>
                    </div>
                    
                    <div className='mt-4'>
                        <CustomFilterTable
                            formDataFilter={filtri}
                            setFormDataFilter={setFiltri}
                            onFilteredTable={fetchRendicontazioni}
                            isLoadingData={loadingStateAdmin.isFinding}
                            searchNodeType={[
                                {
                                    nodeType: "select", name: "stato",
                                    options: [
                                        { label: "Tutti gli stati", value: "" },
                                        { label: "Verifica Amministrativa", value: "Verifica Amministrativa" },
                                        { label: "Da Liquidare", value: "Da Liquidare" },
                                        { label: "Liquidazione Sospesa", value: "Liquidazione Sospesa" }
                                    ]
                                },
                                {
                                    nodeType: "component",
                                    component: <CustomSearch
                                        field="nome"
                                        searchApi={getSuperpartnerByParams} // <-- PUNTO CHIAVE CORRETTO
                                        placeholder="Cerca superpartner..."
                                        selectedItem={filtri.superpartner}
                                        setSelectedItem={(item) => setFiltri(prev => ({ ...prev, superpartner: item }))}
                                    />
                                }
                            ]}
                        />
                    </div>

                    <div className="mt-3">
                        {loadingStateAdmin.isFinding ? <LoadingTable loadingCol={7} /> :
                            filteredList.length > 0 ? (
                                <CustomTable data={filteredList} columns={rendicontazioneConfigTable} actions={actions} />
                            ) : (
                                <div className='mt-5 pt-5 text-center'><p>Nessuna rendicontazione da gestire.</p></div>
                            )
                        }
                    </div>
                </div>
            </div>

            {selectedRendicontazione && (
                <CustomModal show={showStatoModal} onHide={handleCloseModal} onUndoChanges={handleCloseModal} headerText="Modifica Stato" onSave={handleUpdateStato}  isLoading={loadingStateAdmin.isUpdating} btnText="Salva" body={
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nuovo Stato</Form.Label>
                            <Form.Select value={statoFormData.stato} onChange={(e) => setStatoFormData(prev => ({...prev, stato: e.target.value}))}>
                                <option value="Verifica Amministrativa">Verifica Amministrativa</option>
                                <option value="Da Liquidare">Da Liquidare</option>
                                <option value="Liquidazione Sospesa">Liquidazione Sospesa</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Note per il superpartner</Form.Label>
                            <Form.Control as="textarea" rows={3} value={statoFormData.note} onChange={(e) => setStatoFormData(prev => ({...prev, note: e.target.value}))} />
                        </Form.Group>
                    </Form>
                }/>
            )}

            {selectedRendicontazione && (
                <CustomModal show={showLiquidaModal} onHide={handleCloseModal}  onUndoChanges={handleCloseModal} headerText="Liquida Provvigioni" onSave={handleLiquida} isLoading={loadingStateAdmin.isLiquidating} btnText="Conferma" body={
                    <Form>
                        <Alert variant="light">Stai per liquidare <strong>€ {parseFloat(selectedRendicontazione.totale_provvigioni).toFixed(2)}</strong> al superpartner <strong>{selectedRendicontazione.nome_superpartner}</strong>.</Alert>
                        <Form.Group className="mb-3">
                            <Form.Label>Data Liquidazione</Form.Label>
                            <Form.Control type="date" value={liquidaFormData.data_liquidazione} onChange={(e) => setLiquidaFormData(prev => ({...prev, data_liquidazione: e.target.value}))} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Carica Ricevuta Pagamento</Form.Label>
                            <Form.Control type="file" accept=".pdf" onChange={(e) => setLiquidaFormData(prev => ({...prev, ricevuta: e.target.files[0]}))} />
                        </Form.Group>
                    </Form>
                }/>
            )}
            
            {selectedRendicontazione && (
                <RendicontazioneDettaglioModal
                    show={showDettaglioModal}
                    onHide={handleCloseModal}
                    isLoading={loadingStateAdmin.isFinding}
                    rendicontazione={selectedRendicontazione}
                    dettaglio={dettaglioData}
                />
            )}
        </>
    );
};

export default DashboardRendicontazioneSuperpartnerPage;